/* template */
<template><div class="mpx-root-view"><div class="main"><ChildTab :tabs="(tabsData)" :actived="(tabChoosed)" @tabTap="onTabTap" v-if="(tabsData.length > 0)"/><CitySelect :type="(supportMutipleCity ? 'mutiple' : 'single')" :fromCitys="(showCitys.fromCitys)" :toCitys="(showCitys.toCitys)" exchangeIcon="https://ut-static.udache.com/webx/sfc/JsPgN2DbbpIWdjLaBQLfd.png" @exchange="onExchange" @cityTap="onCityTap"/><DateSelect :type="(dateSelectType)" :fromDate="(selectDate.fromDate)" :toDate="(selectDate.toDate)" @dateTap="onDateTap" :fuzzy="(fuzzy)" :fuzzyDate="(selectDate.fuzzyDate)"/><Cabin v-if="(cabinVisible)"/><mpx-view @tap="queryConfirm" class="query-button-area"><div class="query-button">查询机票</div><BubbleBtn :bubbleText="(bubbleText)" class="bubble-btn"/></mpx-view></div><CalendarPopup bizType="flights" :value="calendarPopupVisible" mpxModelEvent="input" @mpxModel='__model("calendarPopupVisible", $event, ["value"], undefined)' :minDate="(calendarConfig.minDate)" :maxDate="(calendarConfig.maxDate)" :subTexts="(calendarConfig.prices)" :type="(calendarConfig.type)" :selectDate="(calendarConfig.selectDate)" :fuzzy="(fuzzy)" :fuzzyDate="(selectDate.fuzzyDate)" @confirm="onCalendarConfirm"/><CityPopup :value="cityPopupVisible" mpxModelEvent="input" @mpxModel='__model("cityPopupVisible", $event, ["value"], undefined)' :title="(cityPopupTitle)" bizType="flights" @confirm="cityConfirm"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m313f25c1"}'>
.main
  background #fff
  border-radius 16px
  overflow hidden
  padding 0 16px 16px
  margin-bottom 8px
  .query-button-area
    position relative
    .query-button
      height 50px
      line-height 50px
      font-size 16px
      text-align center
      color white
      border-radius 12px
      background-color #FF6400
      font-weight 600
    .bubble-btn
      position absolute
      top -10px
      right 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m313f25c1"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./query-card-flights.mpx.js?isComponent&outputPath=components%2Fquery-card-flights313f25c1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./query-card-flights.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fquery-card-flights313f25c1%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m313f25c1"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/query-card-flights313f25c1/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'BubbleBtn':getComponent(require("../bubble-btn/index.mpx?isComponent&outputPath=components%2Findexd2aa2f48%2Findex")),'ChildTab':getComponent(require("./child-tab.mpx?isComponent&outputPath=components%2Fchild-tab0555aa08%2Findex")),'CitySelect':getComponent(require("./city-select.mpx?isComponent&outputPath=components%2Fcity-select113fd9f6%2Findex")),'DateSelect':getComponent(require("./date-select.mpx?isComponent&outputPath=components%2Fdate-select7b67e85a%2Findex")),'Cabin':getComponent(require("./cabin.mpx?isComponent&outputPath=components%2Fcabin8495bcfe%2Findex")),'CalendarPopup':getComponent(require("../../../../components/calendar-popup/index.mpx?isComponent&outputPath=components%2Findexdece9006%2Findex")),'CityPopup':getComponent(require("../../../../components/city-popup/index.mpx?isComponent&outputPath=components%2Findexd7a651ac%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
